import React from 'react'
import styled from 'styled-components';
import { Imglist } from '../../constants/ImagesList';

export default (props) => {
    return (
        <ChooseContent className="choose">
            <div className="choose__logo">
                <img src={Imglist.logo} alt=''/>
            </div>
            <div className="choose__btn-group">
                {props.userDataRedux
                    ?
                        <div className="choose__btn" onClick={()=>props.handleLogout()}>
                            <img src={Imglist.btn_logout} alt=''/>
                        </div> 
                    :
                        <a href={props.loginUrlRedux} className="choose__btn">
                            <img src={Imglist.btn_login} alt=''/>
                        </a>
                }
                <div className="choose__btn" onClick={()=>props.handleDetail()}>
                    <img src={Imglist.btn_detail} alt=''/>
                </div>
                <div className="choose__btn" onClick={()=>props.handleReward()}>
                    <img src={Imglist.btn_reward} alt=''/>
                </div>
                {props.userProfile.manager_name && 
                    <div className="choose__managername">{props.userProfile.manager_name}</div>
                }
            </div>
            <div className="choose__join">
                <div className="choose__item choose__item--1">
                    <img src={Imglist.join_blue} alt=''/>
                    {props.userDataRedux && props.allowJoin
                        ?
                            <img src={Imglist.btn_join_blue} alt='' className="choose__btn-join" onClick={()=>props.handleJoin('blue')}/>
                        :
                            <img src={Imglist.btn_join_blue} alt='' className="choose__btn-join disable"/>
                    }
                </div>
                <div className="choose__item choose__item--2">
                    <img src={Imglist.join_red} alt=''/>
                    {props.userDataRedux && props.allowJoin
                        ?
                            <img src={Imglist.btn_join_red} alt='' className="choose__btn-join red" onClick={()=>props.handleJoin('red')}/>
                        :
                            <img src={Imglist.btn_join_red} alt='' className="choose__btn-join red disable"/>
                    }
                </div>
                <div className="choose__item choose__item--3">
                    <img src={Imglist.join_yellow} alt=''/>
                    {props.userDataRedux && props.allowJoin
                        ?
                            <img src={Imglist.btn_join_yellow} alt='' className="choose__btn-join" onClick={()=>props.handleJoin('yellow')}/>
                        :
                            <img src={Imglist.btn_join_yellow} alt='' className="choose__btn-join disable"/>
                    }
                </div>
                <div className="choose__item choose__item--4">
                    <img src={Imglist.join_green} alt=''/>
                    {props.userDataRedux && props.allowJoin
                        ?
                            <img src={Imglist.btn_join_green} alt='' className="choose__btn-join green" onClick={()=>props.handleJoin('green')}/>
                        :
                            <img src={Imglist.btn_join_green} alt='' className="choose__btn-join green disable"/>
                    }
                </div>
            </div>
        </ChooseContent>
    );
}

const ChooseContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .choose{
        &__logo{
            margin-top: 1%;
            width: 50%;
        }
        &__btn-group{
            width: 100%;
            text-align: center;
            z-index: 2;
        }
        &__btn{
            width: 9%;
            margin: -3% 1% 0;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            >img{
                width: 100%;
                display: block;
            }
            &:hover{
                opacity: .8;
            }
        }
        &__managername{
            margin-top: -1%;
            font-size: 1.5vw;
        }
        &__join{
            position: absolute;
            width: 86%;
            bottom: -2%;
            white-space : nowrap;
            z-index: 1;
        }
        &__item{
            width: 30%;
            display: inline-block;
            vertical-align: bottom;
            &--1{
                position: relative;
                margin-left: -2%;
                z-index: 5;
            }
            &--2{
                position: relative;
                margin-left: -5%;
                z-index: 4;
            }
            &--3{
                position: relative;
                margin-left: -5.6%;
                z-index: 3;
            }
            &--4{
                position: relative;
                width: 29.2%;
                margin-left: -5.3%;
                z-index: 2;
            }
            @media(min-width: 1024px) {
                transition: all .3s ease;
                &:hover{
                    transform: translateY(-5%);
                }
            }
        }
        &__btn-join{
            position: absolute;
            left: 50%;
            transform: translate(-50%,0);
            bottom: 11%;
            width: 60%;
            cursor: pointer;
            &:hover{
                opacity: .8;
            }
            &.red{
                width: 55%;
            }
            &.green{
                width: 59%;
            }
        }
    }
`;